import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useEffect } from 'react'
import { Nav, Offcanvas } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth';
import { UserRole } from '../models/User';

interface SidebarLinkInterface {
  key: string,
  url: string,
  icon: IconProp,
  hideIfTenant?: boolean,
  hideIfCore?: boolean,
  hideIfDoctor?: boolean,
  showOnlyForDoctor?: boolean
}

type SidebarProps = {
  show: boolean;
  onClose?: Function;
}

type SidebarLinkProps = {
  link: SidebarLinkInterface;
}

const NAVIGATION_MENU: SidebarLinkInterface[] = [
  { key: 'home', url: '/home', icon: solid('home') },
  { key: 'organization', url: '/organization', icon: solid('sitemap'), hideIfCore: true, hideIfDoctor: true },
  { key: 'users', url: '/users', icon: solid('list-dots'), hideIfCore: true, hideIfDoctor: true },
  { key: 'doctors', url: '/doctors', icon: solid('user-doctor'), hideIfCore: true, hideIfDoctor: true },
  { key: 'patients', url: '/patients', icon: solid('hospital-user'), hideIfCore: true },
  { key: 'calendar', url: '/me/calendar', icon: solid('calendar'), hideIfCore: true, showOnlyForDoctor: true },
  { key: 'groups', url: '/groups', icon: solid('users'), hideIfCore: true },
  { key: 'pathologies', url: '/pathologies', icon: solid('disease') },
  { key: 'tasks', url: '/tasks', icon: solid('tasks'), hideIfTenant: true },
  { key: 'metrics', url: '/metrics', icon: solid('chart-column'), hideIfTenant: true },
  { key: 'protocols', url: '/protocols', icon: solid('calendar-check'), hideIfTenant: true },
  { key: 'batteries', url: '/batteries', icon: solid('layer-group'), hideIfTenant: true },
  { key: 'devices', url: '/devices', icon: solid('tablet-button'), hideIfTenant: true },
  { key: 'batteries', url: '/tenant-batteries', icon: solid('layer-group'), hideIfCore: true },
  { key: 'devices', url: '/tenant-devices', icon: solid('tablet-button'), hideIfCore: true },
  { key: 'protocols', url: '/tenant-protocols', icon: solid('calendar-check'), hideIfCore: true },
  { key: 'organizations', url: '/organizations', icon: solid('sitemap'), hideIfTenant: true },
  { key: 'telemetry', url: '/telemetry', icon: solid('chart-column'), hideIfCore: true }
]




const USER_NAVIGATION_MENU: SidebarLinkInterface[] = [
  { key: 'home', url: '/home', icon: solid('home') },
  { key: 'calendar', url: '/me/calendar', icon: solid('calendar') },
]



function SidebarLink({ link }: SidebarLinkProps) {
  const { t } = useTranslation();


  const location = useLocation();
  const match = location.pathname.startsWith(link.url);

  return (
    <Link className={classNames("sidebar-link", { active: match })} to={link.url}>
      <FontAwesomeIcon icon={link.icon} fixedWidth={true} />
      <span className="ms-3">{t(`pages.${link.key}`)}</span>
    </Link>
  );
}

export default function AppSidebar({ show, onClose }: SidebarProps) {
  const location = useLocation();
  const { loggedUser } = useAuth();

  // eslint-disable-next-line
  useEffect(() => onClose!(), [location.pathname]);

  return (
    <Offcanvas show={show} onHide={onClose}>
      <div className="app-sidebar">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {/* some optional title here */}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="sidebar-content">
          <Nav defaultActiveKey="/" className="flex-column">
            {(loggedUser!?.role === UserRole.PATIENT || loggedUser!?.role === UserRole.CAREGIVER) ? 
            USER_NAVIGATION_MENU.map(link => (<SidebarLink key={link.key} link={link} />)) 
            : 
            NAVIGATION_MENU.filter(link => (window.__env.TENANT_PATH === "core" && !link.hideIfCore)
                || (window.__env.TENANT_PATH !== "core" && !link.hideIfTenant)
              ).filter(link => (loggedUser?.role === UserRole.DOCTOR && link.hideIfDoctor) || (loggedUser?.role !== UserRole.DOCTOR && link.showOnlyForDoctor) ? false : true)
              .map(link => (
                <SidebarLink key={link.key} link={link} />
              ))}
          </Nav>
        </Offcanvas.Body>
      </div>
    </Offcanvas>
  )
}